import { a as o, j as t, F as u } from "../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as C } from "react";
import { Colors as s } from "../../1-foundations/Colors/Colors.js";
import { I } from "../../../Icon-IZV2yalv.js";
import "../../../FeatureFlagProvider-C_WBizLB.js";
import "@ionic/react";
import "../../../react-paginate-Lh5zQzpz.js";
import "../LoadingInterstitial/LoadingInterstitial.js";
import "../../contexts/DesignSystemProvider/DesignSystemProvider.js";
function A(p) {
  const {
    title: a,
    chip: l,
    children: d,
    isOpen: n,
    onToggle: i,
    titleStyle: c,
    style: m,
    headerStyle: h
  } = p, [f, x] = C(n ?? !1), r = n !== void 0, e = r ? n : f;
  function y() {
    r ? i == null || i() : x((g) => !g);
  }
  return /* @__PURE__ */ o(u, {
    children: [/* @__PURE__ */ t("div", {
      style: {
        padding: "16px 0",
        backgroundColor: s.white200,
        borderBottom: `1px solid ${s.slate300}`,
        ...m
      },
      children: /* @__PURE__ */ o("div", {
        style: {
          padding: "8px 16px",
          display: "flex",
          justifyContent: "space-between",
          ...h
        },
        children: [/* @__PURE__ */ o("div", {
          style: {
            display: "flex",
            gap: 16,
            alignItems: "center"
          },
          children: [/* @__PURE__ */ t("span", {
            style: {
              fontWeight: 500,
              lineHeight: "24px",
              letterSpacing: "0.15px",
              fontSize: 20,
              ...c
            },
            children: a
          }), l && l]
        }), /* @__PURE__ */ t("button", {
          style: {
            background: "none"
          },
          onClick: y,
          "aria-expanded": e,
          "aria-label": e ? "Collapse section" : "Expand section",
          children: /* @__PURE__ */ t(I, {
            name: e ? "Chevron Up" : "Chevron Down"
          })
        })]
      })
    }), e && d]
  });
}
export {
  A as Accordion
};
